var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7378 14.2417H20.3365V15.4423C20.3365 15.7608 20.463 16.0661 20.6881 16.2913C20.9133 16.5165 21.2187 16.643 21.5371 16.643C21.8555 16.643 22.1609 16.5165 22.3861 16.2913C22.6113 16.0661 22.7378 15.7608 22.7378 15.4423V14.2417Z",
    fill: "#04758E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 9.43896V11.8402H15.5339V15.4421C15.5339 17.0343 16.1664 18.5612 17.2922 19.687C18.418 20.8128 19.945 21.4453 21.5371 21.4453C19.945 21.4453 18.418 22.0778 17.2922 23.2036C16.1664 24.3294 15.5339 25.8563 15.5339 27.4485V31.0504H14.3333V33.4516H28.7409V31.0504H27.5403V27.4485C27.5403 25.8563 26.9078 24.3294 25.782 23.2036C24.6562 22.0778 23.1293 21.4453 21.5371 21.4453C22.3255 21.4453 23.1061 21.29 23.8344 20.9883C24.5628 20.6866 25.2245 20.2445 25.782 19.687C26.3394 19.1296 26.7816 18.4678 27.0833 17.7394C27.385 17.0111 27.5403 16.2305 27.5403 15.4421V11.8402H28.7409V9.43896H14.3333ZM17.9352 11.8402H25.139V15.4421C25.139 16.3974 24.7595 17.3136 24.084 17.9891C23.4086 18.6645 22.4924 19.044 21.5371 19.044C20.5818 19.044 19.6657 18.6645 18.9902 17.9891C18.3147 17.3136 17.9352 16.3974 17.9352 15.4421V11.8402ZM17.9352 27.4485V31.0504H25.139V27.4485C25.139 26.4932 24.7595 25.577 24.084 24.9015C23.4086 24.226 22.4924 23.8466 21.5371 23.8466C20.5818 23.8466 19.6657 24.226 18.9902 24.9015C18.3147 25.577 17.9352 26.4932 17.9352 27.4485Z",
    fill: "#04758E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.809fb3270d2e822100e9022a34a940e2.svg";
export { ForwardRef as ReactComponent };